import * as React from 'react'
import { useParams } from 'react-router-dom'

import { useQuery } from '@apollo/client'
import { BookkeepersManagementIncidenceDocument } from 'generated/resources/graphql'

import createComputed from 'modules/core/hooks/createComputed'

import { useIncidences } from 'modules/bookkeepers/hooks/IncidencesContext'
import type { IncidenceQueryData } from 'modules/bookkeepers/hooks/useGetIncidences'
import { useBookkeeperView } from 'modules/bookkeepers/lib/bookkeeperViewContext'

const getIncidence = createComputed(
  (incidenceId: number, incidences?: IncidenceQueryData[] | null) => {
    return incidences?.find((incidence) => incidence.id === incidenceId) || null
  }
)

const useGetCurrentIncidence = () => {
  const { id } = useParams()
  const incidenceId = Number(id)
  const incidences = useIncidences()
  const incidenceData = getIncidence(incidenceId, incidences).get()
  const [incidence, setIncidence] = React.useState<IncidenceQueryData | null>(incidenceData)
  const isBookkeeperView = useBookkeeperView()

  if (incidence?.id !== incidenceId && incidenceData) {
    setIncidence(incidenceData)
  }

  const pauseFetch = !incidenceId || !!incidenceData

  const { data, loading } = useQuery(BookkeepersManagementIncidenceDocument, {
    variables: {
      ids: [incidenceId],
    },
    context: {
      isBookkeeperView,
    },
    skip: pauseFetch,
  })

  const fetchedIncidence = data?.bookkeepersManagement?.incidences[0]

  if (!loading && !pauseFetch && fetchedIncidence?.id !== incidence?.id) {
    setIncidence(data?.bookkeepersManagement?.incidences[0] || null)
  }

  return { loading, incidence }
}

export default useGetCurrentIncidence
